import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

export const PROCEDURES_BY_SPECIALTY = gql`
    query proceduresBySpecialty($specialtyId: String, $additionalProcedureIds: [String]) {
        proceduresBySpecialty(specialtyId: $specialtyId, additionalProcedureIds: $additionalProcedureIds){
            id
            name
        }
    }
`;

export const withSpecialtyProcedures = ({
    ownProp = 'specialtyId',
    specialtyId,
    mapResultToPropName = 'procedures',
} = {}) =>
    graphql(PROCEDURES_BY_SPECIALTY, {
        skip: ownProps => {
            specialtyId = specialtyId || ownProps[ownProp];
            return !specialtyId;
        },
        options: () => ({
            ssr: true,
            variables: { specialtyId },
        }),
        props: ({ data: { proceduresBySpecialty } }) => ({ [mapResultToPropName]: proceduresBySpecialty }),
    });
